import { useState } from "react";
import { useDispatch } from 'react-redux';

import TroubleshootFilter from "./TroubleshootFilter";
//import TroubleshootGeneral from "./TroubleshootGeneral";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';
import useAccess from "../../hooks/useAccess";
import LoadingComponent from "../Commons/LoadingComponent";

import { getLabel } from "../../tools/Dictionary";

import "./Troubleshoot.css";

const TroubleshootPage = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();
  const Access = useAccess(["Trouble"]);

  //state
  const [loading, setLoading] = useState(false);



  useMount(() =>
  {
    Dispatch(setCurrentNavigation("Trouble"));
  }, []);

  if (!Access.canRead)
    return (
      <div className="page_cont">
        <div className="page_message_text">
          {getLabel("App", "Access Denied: You don't have...")}
        </div>
      </div>
    );

  return (
    <div className="page_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <TroubleshootFilter IsDesktop={IsDesktop} ParentLoading={loading} setParentLoading={setLoading} Access={Access} />
    </div>
  )

};

//<TroubleshootGeneral IsDesktop={IsDesktop} ParentLoading={loading} setParentLoading={setLoading} Access={Access} />

export default TroubleshootPage;